export default __webpack_public_path__ + "bb26e21ce8b7d482daaaede48edfc161.png";